module.exports = __webpack_public_path__ + "static/14-75f8f7be0fb9c84e9c11dfe1ab5862f8.jpg";